<div class="client-property-label">
	<span>{{ 'additional-questions.audit-dates.transfer-audit-date' | translate }}</span>
	<change-label [visible]="isDesiredNextAuditDateChanged()" [changeSet]="changeSet"></change-label>
</div>
<div class="client-property">
	@if (product.additionalQuestions.desiredNextAuditDate) {
		<span>{{ product.additionalQuestions.desiredNextAuditDate | localizedDate | async }}</span>
	}
	@if (!product.additionalQuestions.desiredNextAuditDate) {
		<span class="placeholder">{{ 'additional-questions.audit-dates.date-not-provided' | translate }}</span>
	}
</div>

<div class="client-property-label">
	<span>{{ 'additional-questions.transfer-questions.transfer-reason' | translate }}</span>
	<change-label [visible]="isTransferReasonChanged()" [changeSet]="changeSet"></change-label>
</div>
<div class="client-property">
	{{ product.additionalQuestions.transferQuestions.transferReason }}
	@if (translationsHelper.translationExists(product.standard.name, 'additionalQuestions.transferReason', useOriginalTranslations)) {
		<translation-field [standard]="product.standard.name"
						   [previewMode]="!translateClientsData"
						   [translatedText]="translationsHelper.getTranslation(product.standard.name, 'additionalQuestions.transferReason', useOriginalTranslations)"
						   [translationSubject]="'additionalQuestions.transferReason'"></translation-field>
	}
</div>

<div class="form-row with-padding-bottom radio-row">
	<div class="radio-with-question">
		<div class="radio-column">
			<nb-radio [name]="'isCurrentCertificationBodyAccredited' + RANDOM_NUMBER" [checked]="true" status="primary">
				{{ product.additionalQuestions.transferQuestions.isCurrentCertificationBodyAccredited | booleanDisplay }}
			</nb-radio>
		</div>
		<div class="radio-description-column">
			<span>{{ 'additional-questions.transfer-questions.cb-accredited' | translate }}</span>
			<change-label [visible]="isCbAccreditedChanged()" [changeSet]="changeSet"></change-label>
		</div>
	</div>
</div>

<div class="form-row with-padding-bottom radio-row">
	<div class="radio-with-question">
		<div class="radio-column">
			<nb-radio [name]="'hasOpenNonConformities' + RANDOM_NUMBER" [checked]="true" status="primary">
				{{ product.additionalQuestions.transferQuestions.hasOpenNonConformities | booleanDisplay }}
			</nb-radio>
		</div>
		<div class="radio-description-column">
			<span>{{ 'additional-questions.transfer-questions.open-non-conformities' | translate }}</span>
			<change-label [visible]="areOpenNonConformitiesChanged()" [changeSet]="changeSet"></change-label>
		</div>
	</div>
</div>

@if (product.additionalQuestions.transferQuestions.hasOpenNonConformities) {
	<div class="form-row with-padding-bottom radio-row">
		<div class="radio-with-question">
			<div class="radio-column">
				<nb-radio [name]="'hasCorrectiveActionPlans' + RANDOM_NUMBER" [checked]="true" status="primary">
					{{ product.additionalQuestions.transferQuestions.hasCorrectiveActionPlans | booleanDisplay }}
				</nb-radio>
			</div>
			<div class="radio-description-column">
				<span>{{ 'additional-questions.transfer-questions.corrective-action-plans' | translate }}</span>
				<change-label [visible]="isCorrectivePlansChanged()" [changeSet]="changeSet"></change-label>
			</div>
		</div>
	</div>
	<div class="row-wrapper">
		<div class="col-md-6">
			<div class="client-property-label">
				<span>{{ 'additional-questions.transfer-questions.major-non-conformities' | translate }}</span>
				<change-label [visible]="areMajorNonConformitiesChanged()" [changeSet]="changeSet"></change-label>
			</div>
			<div class="client-property">
				{{ product.additionalQuestions.transferQuestions.numberOfMajorNonConformities }}
			</div>
		</div>
		<div class="col-md-6">
			<div class="client-property-label">
				<span>{{ 'additional-questions.transfer-questions.minor-non-conformities' | translate }}</span>
				<change-label [visible]="areMinorNonConformitiesChanged()" [changeSet]="changeSet"></change-label>
			</div>
			<div class="client-property">
				{{ product.additionalQuestions.transferQuestions.numberOfMinorNonConformities }}
			</div>
		</div>
	</div>
}

<div class="row-wrapper">
	<div class="col-md-6">
		<div class="client-property-label">
			<span>{{ 'additional-questions.transfer-questions.last-audit-performed' | translate }}</span>
			<change-label [visible]="isLastAudiPerformedChanged()" [changeSet]="changeSet"></change-label>
		</div>
		<div class="client-property">
			{{ product.additionalQuestions.transferQuestions.lastAuditPerformedDate | localizedDate | async }}
		</div>
	</div>
	<div class="col-md-6">
		<div class="client-property-label">
			<span>{{ 'additional-questions.transfer-questions.cert-exp-date' | translate }}</span>
			<change-label [visible]="isExpirationDateChanged()" [changeSet]="changeSet"></change-label>
		</div>
		<div class="client-property">
			{{ product.additionalQuestions.transferQuestions.expirationDate | localizedDate | async }}
		</div>
	</div>
</div>
